// extracted by mini-css-extract-plugin
export default {"anika":"Intro_anika__5go4z","ctext":"Intro_ctext__p8XW1","img":"Intro_img__9bSCP","main":"Intro_main__QI3Ut"};